/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleRecommendationReactivateRequest extends models.ScheduleRecommendationActionBaseRequest {
    getFixupPrototypeFunction() { return ScheduleRecommendationReactivateRequest.fixupPrototype; }

    static newInstance(model: Partial<ScheduleRecommendationReactivateRequest>): ScheduleRecommendationReactivateRequest {
        let obj = Object.assign(new ScheduleRecommendationReactivateRequest(), model);
        ScheduleRecommendationReactivateRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleRecommendationReactivateRequest>): ScheduleRecommendationReactivateRequest {
        if (!model) return null;
        return ScheduleRecommendationReactivateRequest.newInstance(<ScheduleRecommendationReactivateRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleRecommendationReactivateRequest) {
        if (!obj) return;

        models.ScheduleRecommendationReactivateRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleRecommendationReactivateRequest): boolean {
        if (models.ScheduleRecommendationActionBaseRequest.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ScheduleRecommendationReactivateRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
